import React, { useEffect, useState, type FC } from 'react';
import cn from 'clsx';
import { square } from '../../../../providers/square';
import { type FieldName } from '../../../../types/CardFieldName';
import { type FieldState } from '../../../../types/Field';
import { FieldErrorMessage } from '../../../FieldErrorMessage';
import { squareFormContainerId } from '../../../../providers/square/constants';
import s from './styles.scss';

export interface FieldProps {
  onFocus?(e: any): void;
  onBlur?(e: any): void;
}

export interface FieldEntity {
  fieldName: FieldName;
  props: FieldProps;
  state: FieldState;
}

export interface SquareCardFormProps {
  fields: FieldEntity[];
}

export interface handleFocusParams {
  onFocus?: FieldProps['onFocus'];
  onBlur?: FieldProps['onBlur'];
}

export const SquareCardForm: FC<SquareCardFormProps> = (props) => {
  const [isFocus, setIsFocus] = useState(false);

  const handleFocus = (params: handleFocusParams) => (shouldFocus: boolean, e?) => {
    if (shouldFocus) {
      params.onFocus?.(e);
      setIsFocus(true);
    } else {
      params.onBlur?.(e);
      setIsFocus(false);
    }
  };

  useEffect(() => {
    props.fields.forEach((field) => {
      square.api.listenFieldFocus(field.fieldName, handleFocus(field.props));
    });

    return () => {
      props.fields.forEach((field) => {
        square.api.unlistenAllFieldFocus(field.fieldName);
      });
    };
  }, []);

  const invalidField = props.fields.find((field) => {
    const { isTouched, isValid } = field.state;
    return isTouched && !isValid;
  });

  return (
    <>
      <div
        className={cn(s.container, {
          [s.focus]: isFocus,
          [s.error]: invalidField,
        })}
      >
        <div id={squareFormContainerId} className={s.squareContainer} />
      </div>
      {invalidField && <FieldErrorMessage fieldName={invalidField.fieldName} />}
    </>
  );
};
